/**
 * App.tsx — composition root.
 * Providers + a single NavigationContainer hosting the root navigator.
 * Routing lives under src/navigation/ (rootNavigator → appShell; auth is
 * delegated to the centralized SK Platform via redirect).
 */
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { ThemeProvider } from './src/context/themeContext';
import { SessionProvider } from './src/context/sessionContext';
import { CurrencyProvider } from './src/context/currencyContext';
import { ToastProvider } from './src/components/skToast';
import { Toast } from './src/components/skToast';
import RootNavigator from './src/navigation/rootNavigator';
import { navigationRef } from './src/navigation/navigationRef';

export default function App() {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <ThemeProvider>
          <SessionProvider>
            <CurrencyProvider>
            <ToastProvider>
              <NavigationContainer ref={navigationRef}>
                <RootNavigator />
              </NavigationContainer>
              {/* react-native-toast-message host — sits at root, above nav. */}
              <Toast />
            </ToastProvider>
            </CurrencyProvider>
          </SessionProvider>
        </ThemeProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}
